import { z } from 'zod';

export const voiceSettingsSchema = z.object({
    speed: z.number().min(0.70).max(1.20),
    stability: z.number().min(0).max(1),
    similarityBoost: z.number().min(0).max(1),
    style: z.number().min(0).max(1),
    useSpeakerBoost: z.boolean()
});

export type VoiceSettingsDialogState = z.infer<typeof voiceSettingsSchema>;
